import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';

const dyRecommendationTitle = (labelKey, defaultValue) => {
  return labelKey ? getDynamicLabelValues(labelKey) : defaultValue;
};

export default dyRecommendationTitle;
